import { render, staticRenderFns } from "./GroupCreationForm.vue?vue&type=template&id=652b9e2e&scoped=true&lang=pug"
import script from "./GroupCreationForm.vue?vue&type=script&lang=js"
export * from "./GroupCreationForm.vue?vue&type=script&lang=js"
import style0 from "./GroupCreationForm.vue?vue&type=style&index=0&id=652b9e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652b9e2e",
  null
  
)

export default component.exports